import $i from "~/i18n";

export const getMyCourse = async ({ commit }) =>  {
  try {
    let { data } = await axios.post("/course/get-my-course-list");
    if (data.state != 200) return;
    commit("SET_DATA", { data: data.course_list, id: "teachingList" });
  } catch (error) {
    console.log(error);
  }
};
export const getMyEnroll = async ({ commit }) =>  {
  try {
    let { data } = await axios.post("/enroll/get-my-enroll-list");
    if (data.state != 200) return;
    commit("SET_DATA", { data: data.enroll_list, id: "enrollList" });
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/my-courses/actions.js